import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeSyncAdminComponent } from './time-sync-admin/time-sync-admin.component';
import { AppPropertiesService, AppPropertyComponentsModule, CommonLayoutModule, CommonUIModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TimeSyncAdminComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    AppPropertyComponentsModule,
    CommonUIModule
]
})
export class TimeSyncAdminModule {

  constructor(
    private appPropertiesService: AppPropertiesService
  ) {

    appPropertiesService.registerAppPropertiesAdminComponent('tmc-yard.time-sync.ui.tmc-sync-admin.tab-title', TimeSyncAdminComponent);


  }

}
